import React, { Component } from "react";
import * as R from "ramda";
import { monthOptions, yearOptions } from "../../config";
import { configVariantSales, configVariantSalesYearToDate } from "../config";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import Api from "../../../../../Services/Api";
import { HttpStatus } from "../../../../common/Constants";
import { fetchDataAsync } from "../../../../../Services/Utils";
import moment from "moment";

class VariantSalesReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      month: monthOptions.find((item) => item.value === moment().month() + 1),
      year: yearOptions[0],
      dataTable: [],
      tableConfig: [],
    };
  }

  componentDidMount = () => {
    this.setState(
      (prevValue) => ({
        ...prevValue,
        tableConfig: R.equals(this.props.tab, "variant")
          ? configVariantSales
          : R.equals(this.props.tab, "ytd")
          ? configVariantSalesYearToDate()
          : [],
      }),
      () => this.fetchData()
    );
  };

  componentDidUpdate = (prevProps) => {
    if (!R.equals(prevProps.search, this.props.search)) {
      this.fetchData();
    }
  };

  fetchData = async () => {
    this.props.triggerLoading();
    const request = {
      kodeCabangList: [this.props.search],
      month: R.equals(this.props.tab, "variant")
        ? this.state.month?.value
        : null,
      year: this.state.year?.value,
      teamLeaderEmployeeId: this.props.user.user.employeeId,
      salesId: null,
      limit: 10,
      page: 1,
    };
    let url = R.equals(this.props.tab, "variant")
      ? Api.create("NAGAMAS_REPORT_DTO").getLaporanPenjualanPerVariantKacab
      : R.equals(this.props.tab, "ytd")
      ? Api.create("NAGAMAS_REPORT_DTO").getLaporanPenjualanPerVariantYTD
      : null;
    let res = await fetchDataAsync({
      asyncFn: url,
      menuName: "Dashboard Level Team Leader - Laporan Jual Varian",
      setError: this.props.setError,
      args: request,
    });
    if (
      res.ok &&
      res.data.status === HttpStatus.SUCCESS &&
      !R.isNil(res.data.data)
    ) {
      this.setState((prevValue) => ({
        ...prevValue,
        dataTable: res.data.data,
      }));
    }
    this.props.triggerLoading();
  };

  handleSearchValueChange = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  };

  handleSearch = () => {
     this.setState(
      (prevValue) => ({
        ...prevValue,
        tableConfig: R.equals(this.props.tab, "variant")
          ? configVariantSales
          : R.equals(this.props.tab, "ytd")
          ? configVariantSalesYearToDate(prevValue?.year?.value)
          : [],
      }),
      () => this.fetchData()
    );
  }

  render() {
    return (
      <>
        <FlexView style={{ gap: "20px", alignItems: "center" }}>
          {R.equals(this.props.tab, "variant") && (
            <SimpleDDL
              id="select_options_month"
              box="search"
              name="month"
              isClearable
              containerclassname="width width-250px"
              placeholder="Bulan"
              menuPosition="fixed"
              options={monthOptions}
              value={this.state.month}
              onChange={(value, { name }) =>
                this.handleSearchValueChange(name, value)
              }
            />
          )}
          <SimpleDDL
            id="select_options_year"
            box="search"
            isClearable
            name="year"
            containerclassname="width width-250px"
            placeholder="Tahun"
            menuPosition="fixed"
            options={yearOptions}
            value={this.state.year}
            onChange={(value, { name }) =>
              this.handleSearchValueChange(name, value)
            }
          />
          <SimpleButton
            styles={{ marginBottom: "15px" }}
            onClick={()=>this.handleSearch()}
          >
            Cari
          </SimpleButton>
        </FlexView>
        <SimpleDataTable
          data={this.state.dataTable}
          columns={this.state.tableConfig}
          toCount={0}
          rowsPerPage={10}
          page={0}
        />
      </>
    );
  }
}

export default VariantSalesReport;
